module.exports = __webpack_public_path__ + "static/media/s_v5_t10_2.d067913b.mp3";